// Re-flowing the approved scope text for print (Owner device test 2026-09-21: 「中英文报告多处排版问题」).
//
// The approved Inspection Agreement scope (src/domain/agreementText.ts — legal text, byte for byte) came
// from a plain-text production copy that was HARD-WRAPPED at about a hundred characters:
//
//     NOT INCLUDED. The inspection is visual and non-invasive. It does not include dismantling
//     equipment, moving stored items or finishes, entering unsafe or inaccessible areas, or operating
//     systems that are shut down. …
//     · Mold, radon, asbestos, lead, indoor air quality, wood-destroying insects and pests. These
//       conditions are outside the scope of this general home inspection and may require separate testing
//
// Printing every source line as a paragraph of its own reproduced those breaks on paper: ragged short
// lines in the middle of a sentence, on a page that is wider than the source was. The WORDS are the
// approved text and stay exactly that — every word, in order, none added, none dropped (pinned by
// tests/report/flowText.test.ts against the source). Only the source's line breaks stop being
// paragraph breaks:
//   blank line                       ends a block
//   a line starting with "·"         starts a bullet
//   an indented line                 continues the block above it (a wrapped bullet)
//   any other line                   continues the paragraph above it — unless that paragraph is a
//                                    bullet, or ended with a colon (a heading: "ADDITIONAL SERVICES …:")
export interface FlowBlock {
  kind: 'paragraph' | 'bullet';
  text: string;
}

const CJK = /[⺀-鿿豈-﫿＀-￯　-〿]/;

// English lines are joined by one space; between two CJK characters a line break was never a space.
function join(previous: string, next: string): string {
  const last = previous.slice(-1);
  const first = next.slice(0, 1);
  return CJK.test(last) && CJK.test(first) ? previous + next : `${previous} ${next}`;
}

export function flowHardWrappedText(text: string): FlowBlock[] {
  const blocks: FlowBlock[] = [];
  let open: FlowBlock | null = null;
  for (const raw of text.split(/\r?\n/)) {
    const line = raw.replace(/\s+$/, '');
    if (line.trim().length === 0) {
      open = null;
      continue;
    }
    const indented = /^\s/.test(line);
    const content = line.trim();
    if (content.startsWith('·')) {
      open = { kind: 'bullet', text: content };
      blocks.push(open);
      continue;
    }
    const continues = open !== null && (indented || (open.kind === 'paragraph' && !/[:：]$/.test(open.text)));
    if (continues && open !== null) {
      open.text = join(open.text, content);
      continue;
    }
    open = { kind: 'paragraph', text: content };
    blocks.push(open);
  }
  return blocks;
}
